<!-- ============================= -->
<!-- Menu                          -->
<!-- ============================= -->
<app-menu [isMaintenance]="this.isMaintenance | async"></app-menu>

<!-- ============================= -->
<!-- Application page              -->
<!-- ============================= -->
<ng-container *ngIf="!(isMaintenance | async); else maintenanceTpl">
  <main class="flex-shrink-0">
    <router-outlet />
  </main>
  
  <!-- Application messages-->
  <p-toast position="bottom-right">
    <ng-template let-message pTemplate="message">
      <div class="p-toast-content" (click)="onMessageClick(message)">
        <span class="p-toast-message-icon pi" [ngClass]="'pi-' + getIcon(message.severity)"></span>
        <div class="p-toast-text">
          <span class="p-toast-summary">{{ message.summary }}</span>
          <p id="{{ message.id ?? 'id' }}" class="p-toast-detail">{{ message.detail }}</p>
        </div>
      </div>
    </ng-template>
  </p-toast>
</ng-container>

<!-- ============================= -->
<!-- Maintenance page              -->
<!-- ============================= -->
<ng-template #maintenanceTpl>
  <app-maintenance [maintenanceType]="this.maintenanceType | async"></app-maintenance>
</ng-template>

<!-- ============================= -->
<!-- Confirmation dialog           -->
<!-- ============================= -->
<p-confirmDialog></p-confirmDialog>
<p-confirmDialog key="sessionInactivityWarningDialog" [closable]="false" styleClass="p-confirm-session-dialog">
  <ng-template pTemplate="message" let-message>
    <div class="dialog-content">
      <p>{{ message.message }}</p>
      <p-progressBar [value]="inactivityService.progressValue" [showValue]="true"
        styleClass="custom-progress-bar"></p-progressBar>
    </div>
  </ng-template>
</p-confirmDialog>
<p-confirmDialog key="sessionLogoutDialog" [closable]="false" styleClass="p-confirm-session-dialog"></p-confirmDialog>
<p-confirmDialog key="sessionExpiredDialog" [closable]="false" styleClass="p-confirm-session-dialog"></p-confirmDialog>

<!-- ============================= -->
<!-- Footer                        -->
<!-- ============================= -->
<footer class="footer mt-auto py-3 bg-primary text-light link-light" data-bs-theme="dark">
  <div class="container small text-center">For the UK, as from 1.1.2021, EU Law applies only to the territory of
    Northern Ireland &#40;NI&#41; to the extent foreseen in the Protocol on Ireland&#47;NI</div>
  <div class="container small text-center">
    <a class="link-light ms-2" href="https://www.ema.europa.eu">&copy; European Medicines Agency</a>
    <a class="link-light ms-2" href="https://www.ema.europa.eu/en/about-us/data-protection-privacy">Privacy</a>
    <app-version></app-version>
  </div>
</footer>